import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {
  Button,
  Modal,
  Checkbox,
} from 'react-bootstrap';
import { generate } from 'shortid';

import Passcode from '../../models/Passcode';
import { PasscodeFormValidation } from '../../tools/Validations';
import FieldGroup from '../FieldGroup/FieldGroup';

import './PasscodeDialog.css';

const PasscodeDialog = observer(
class PasscodeDialog extends Component {
  constructor(props) {
    super(props);
    this.ids = {
      name: generate(),
      passcode: generate(),
      enabled: generate(),
      notifySms: generate(),
      notifyEmail: generate(),
    }

    this.formValidation = new PasscodeFormValidation();
    this.state = { disableButtons: false };
  }
  render() {
    let {
      show = false,
      passcode,
    } = this.props;

    passcode = passcode || new Passcode();
    const disableButtons = this.state.disableButtons || !this.formValidation.test(passcode);

    return (
      <Modal show={show} onHide={this.onCancel} autoFocus>
        <Modal.Header closeButton>
          <Modal.Title>{passcode.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={this.onSave}>
            <FieldGroup
              focus
              id={this.ids.name}
              name="name"
              type="text"
              label="Friendly name"
              value={passcode.name}
              placeholder="My home"
              validation={this.formValidation.name}
              onChange={this.handleChange}
              />
            <FieldGroup
              id={this.ids.passcode}
              name="passcode"
              type="text"
              label="Passcode"
              value={passcode.passcode}
              placeholder="e.g. 53428"
              validation={this.formValidation.passcode}
              onChange={this.handleChange} />
            <Checkbox
              id={this.ids.enabled}
              name="enabled"
              checked={passcode.enabled}
              onChange={this.handleChange}>
              Enabled
            </Checkbox>
            <Checkbox
              id={this.ids.notifySms}
              name="notifySms"
              checked={passcode.notifySms}
              onChange={this.handleChange}>
              Notify me by text message (SMS) - Standard message rates may apply
            </Checkbox>
            {/* <Checkbox
              id={this.ids.notifyEmail}
              name="notifyEmail"
              checked={passcode.notifyEmail}
              onChange={this.handleChange}>
              Notify me by E-mail
            </Checkbox> */}
            <div style={{display: "none"}}>
              <Button type="submit" hidden></Button>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="PasscodeDlg-footer">
          <div className="PasscodeDlg-footer-left">
            {
              passcode.id ?
                <Button onClick={this.onDelete} bsStyle="danger" disabled={disableButtons}>Delete</Button> :
                null
            }
          </div>
          <div className="PasscodeDlg-footer-right">
            <Button onClick={this.onCancel}>Cancel</Button>
            <Button onClick={this.onSave} bsStyle="primary" disabled={disableButtons}>Save</Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  handleChange = (e) => {
    let { id, name, value } = e.target;
    if (id === this.ids.enabled ||
        id === this.ids.notifySms ||
        id === this.ids.notifyEmail) {
      value = e.target.checked;
    }
    let data = {};
    data[name] = value;
    this.props.passcode.set(data);
    this.formValidation.test(this.props.passcode);
  }

  onSave = (e) => {
    e.preventDefault();
    this.disableButtons();
    let {
      passcode,
      onSave
    } = this.props;
    if (onSave && this.formValidation.passAllValidations()) {
      onSave(passcode);
    }
    this.disableButtons(false);
    return false;
  }

  onCancel = (e) => {
    e && e.preventDefault && e.preventDefault();
    this.formValidation.reset();
    let { onCancel } = this.props;
    if (onCancel) {
      onCancel();
    }

    return false;
  }

  onDelete = (e) => {
    e.preventDefault();
    this.disableButtons();
    let {
      passcode,
      onDelete
    } = this.props;
    if (onDelete) {
      onDelete(passcode);
    }
    this.disableButtons(false);
    return false;
  }

  disableButtons = (bDisable = true) => {
    this.setState({ disableButtons: bDisable });
  }
});

export default PasscodeDialog;


// WEBPACK FOOTER //
// ./src/components/Property/PasscodeDialog.js